import device from './device'
import kuisioner from './kuisioner'
import listTalent from './list-talent'

export default [...device, ...kuisioner, ...listTalent]
